module.exports = __webpack_public_path__ + "src/assets/img/cmdGoArm.866989c7.svg";